import { render, staticRenderFns } from "./scanWXcode.vue?vue&type=template&id=89f4a4b4&scoped=true&"
import script from "./scanWXcode.vue?vue&type=script&lang=js&"
export * from "./scanWXcode.vue?vue&type=script&lang=js&"
import style0 from "./scanWXcode.vue?vue&type=style&index=0&id=89f4a4b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f4a4b4",
  null
  
)

export default component.exports